import { useState } from "react";

export const DISPLAY_SCALES = [
  { key: "small", label: "Small", size: "87.5%" },
  { key: "default", label: "Default", size: "100%" },
  { key: "large", label: "Large", size: "112.5%" },
  { key: "larger", label: "Larger", size: "125%" },
];

export const applyDisplayScale = (key) => {
  const s = DISPLAY_SCALES.find((x) => x.key === key) || DISPLAY_SCALES[1];
  document.documentElement.style.fontSize = s.size;
};

// Page-zoom style control for the standalone PWA (where pinch-to-zoom is disabled).
// Scales the root font size so text + rem-based spacing grow together, per device.
export const DisplaySize = () => {
  const [scale, setScale] = useState(() => localStorage.getItem("sd_display_scale") || "default");
  const choose = (key) => {
    setScale(key);
    localStorage.setItem("sd_display_scale", key);
    applyDisplayScale(key);
  };
  return (
    <div className="grid grid-cols-4 gap-2" data-testid="display-size">
      {DISPLAY_SCALES.map((s) => (
        <button
          key={s.key}
          onClick={() => choose(s.key)}
          data-testid={`display-size-${s.key}`}
          className={`flex flex-col items-center justify-center gap-0.5 rounded-lg border px-2 py-2.5 font-600 transition-colors ${
            scale === s.key
              ? "border-[#9B2226] bg-[#9B2226]/15 text-[#E0575B]"
              : "border-zinc-800 bg-zinc-950 text-zinc-300 hover:bg-zinc-900"
          }`}
        >
          <span className={s.key === "small" ? "text-xs" : s.key === "default" ? "text-sm" : s.key === "large" ? "text-base" : "text-lg"}>A</span>
          <span className="text-[11px]">{s.label}</span>
        </button>
      ))}
    </div>
  );
};
